import {Component, OnInit, ViewChild} from '@angular/core';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import {Router, ActivatedRoute} from '@angular/router';
import {PageEvent} from '@angular/material/paginator';
import {TableService} from '../services/pager/pager';
import {ReportFilter} from './report.filter';
import {DatePipe} from '@angular/common';
import {WebService} from '../services/web/web.service';
import {SpinnerService} from '../services/spinner/spinner.service';
import {ToastService} from '../services/notification/toast.service';
import {AppConfirmService} from '../app-confirm/app-confirm.service';
import {SecurityService} from "../services/security.service";
import {TranslateService} from '@ngx-translate/core';
import { take } from "rxjs/operators";
import {UserPermissionsService} from "../services/user-permissions.service";
import {MatDialog} from '@angular/material/dialog';
import {RefundInvoiceDialogComponent, RefundDialogResult} from './refund-invoice-dialog/refund-invoice-dialog.component';
import {formatStrictAmount} from '../utils/strict-amount';

@Component({
    selector: 'app-customer-invoices',
    templateUrl: './customer-invoices.component.html',
    styleUrls: ['./customer-invoices.component.scss'],
    providers: [AppConfirmService, DatePipe],
    standalone: false
})
export class CustomerInvoicesComponent implements OnInit {


  // PARA MANEJO DE PANEL DE BUSQUEDA
  isOpenSearchPanel = false;
  filter = new ReportFilter(this.tableService.filter);
 
   // PARA MANEJO DE TABLAS
   @ViewChild(MatPaginator) paginator: MatPaginator | undefined;
   @ViewChild(MatSort) sort: MatSort | undefined;
   displayedColumns: string[] = [ 'invoice', 'estatus', 'plan', 'portal', 'totalInvoice', 'refundedAmount', 'createdAt', 'paymentDate', 'actions'];
   dataSource: any;
  items: any[] = [];
  partner: any;
  customer : any;

    extraFields: boolean = false;
    currency: string | undefined;

    constructor(
        private securityService: SecurityService,
        public tableService: TableService<any>,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private datePipe: DatePipe,
        private confirmService: AppConfirmService,
        private webService: WebService,
        private spinner: SpinnerService,
        private toast: ToastService,
        private translate: TranslateService,
        private dialog: MatDialog,
        private userPermissionsService: UserPermissionsService) {
        this.tableService = new TableService;
    }

    ngOnInit(): void {
        this.isOpenSearchPanel = true;
        this.activatedRoute.params.subscribe(params => {

            this.customer = params["id"];
            this.list();

        }, err => {
            this.toast.showError(err)
        })


    }

    list(event?: PageEvent) {
        if (!this.canViewInvoicesReport()) {
            this.toast.showWarning('No tienes permisos para consultar facturas.');
            this.dataSource = [];
            return;
        }

        this.spinner.open();
        // , 'customer','centro'
        this.displayedColumns = ['invoice', 'estatus', 'plan', 'portal', 'totalInvoice', 'refundedAmount', 'createdAt', 'paymentDate', 'actions'];
        //  118
        this.filter.company = +this.securityService.getTokenPartner();
        this.filter.customer = +this.customer;
        this.items = [];
        if (Object.keys(this.filter).length > 0) { // Para realizar busquedas solo si hay objetos en el filtro


            this.filter.since = this.datePipe.transform(this.filter.since, 'yyyy-MM-dd');
            this.filter.until = this.datePipe.transform(this.filter.until, 'yyyy-MM-dd');

            // @ts-ignore
            var since = new Date(this.filter.since);
            // @ts-ignore
            var until = new Date(this.filter.until);

            if (until.getTime() < since.getTime()) {
                this.spinner.close();
                this.toast.showError(this.translate.instant('customerInvoices.messages.invalidDateRange'));
                return;
            }
            this.tableService.filter = new ReportFilter(this.filter);

            let httpParams = this.webService.buildRequestParams(this.tableService.sort, "m",
                {
                    pageIndex: event ? event.pageIndex : this.tableService.pager.pageIndex,
                    pageSize: event ? event.pageSize : this.tableService.pager.pageSize
                })

            httpParams = this.filter.getHttpParams(httpParams);

            this.webService.get(this.webService.HOST + "/partner/-1/customer/" + this.customer + "/invoices/report", httpParams)
                .subscribe(params => {
                    console.log(params);
                    this.items = params['result']; // items que mostrara la tabla
                    if (this.items.length === 0) {
                        this.dataSource = [];
                        this.spinner.close();
                        this.toast.showInfo(this.translate.instant('customerInvoices.messages.noInvoices'));
                        return;
                    }

                    for (let item of this.items) {
                        var created = new Date(item.createdAt);
                        item.createdAt = this.datePipe.transform(new Date(created.setHours(created.getHours() - 5)), 'yyyy-MM-dd HH:mm:ss');
                    }

                    this.dataSource = new MatTableDataSource<any>(this.items);
                    this.tableService.pager = params['pager'];
                    this.tableService.selection.clear();

                    this.spinner.close();


                }, err => {
                    this.spinner.close();
                    this.toast.showError(err);
                    console.log(err);
                });
        } else {
            console.log("Hola2")
        }
    }

    openPopUp(data: any = {}) {
        if (!this.canRefundInvoice()) {
            this.toast.showWarning('No tienes permisos para reembolsar facturas.');
            return;
        }

        if (data.hasPendingRefund) {
            this.toast.showWarning(this.translate.instant('customerInvoices.messages.refundPending'));
            return;
        }

        if (!data.allowsPartialRefund) {
            this.confirmService.confirm({
                title: this.translate.instant('customerInvoices.messages.refundConfirmTitle'),
                message: this.translate.instant('customerInvoices.messages.refundConfirmMessage')
            }).pipe(take(1)).subscribe(res => {
                if (res) this.sendInvoiceToRefund(data);
            });
            return;
        }

        this.dialog.open(RefundInvoiceDialogComponent, {
            width: '600px',
            maxWidth: '92vw',
            data: {invoiceId: data.id, availableRefundAmount: data.availableRefundAmount, allowsPartialRefund: data.allowsPartialRefund}
        })
            .afterClosed().pipe(take(1)).subscribe((result: RefundDialogResult | undefined) => {
                if (result) this.sendInvoiceToRefund(data, result);
            });
    }

    sendInvoiceToRefund(data: any, result?: RefundDialogResult) {
        if (!this.canRefundInvoice()) {
            this.toast.showWarning('No tienes permisos para reembolsar facturas.');
            return;
        }

        this.spinner.open();
        let obj: any = {id: data.id};
        if (result) {
            obj.refundType = result.refundType;
            if (result.amount) obj.amount = result.amount;
        }
        this.webService.post(obj, this.webService.HOST + "/invoice/refund").subscribe(response => {
            this.spinner.close();
            const amount = result?.amount || Number(data.availableRefundAmount).toFixed(2);
            const balance = Math.max(0, Number(data.availableRefundAmount) - Number(amount)).toFixed(2);
            this.toast.showSuccess(this.translate.instant('customerInvoices.messages.refundSuccess', {amount, balance}));
            this.ngOnInit();

        }, err => {
            console.log(err);
            this.toast.showError(err);
            this.spinner.close();
        });
    }

    private readonly CANCELLABLE_STATUSES: number[] = [0, 5, 50, 70];

    isCancellable(statusInvoice: number): boolean {
        return this.CANCELLABLE_STATUSES.includes(statusInvoice);
    }

    openCancelChargePopUp(data: any): void {
        this.confirmService.confirm({
            title: this.translate.instant('customerInvoices.messages.cancelChargeTitle'),
            message: this.translate.instant('customerInvoices.messages.cancelChargeMessage'),
            confirmText: this.translate.instant('customerInvoices.messages.cancelChargeConfirm'),
            cancelText: this.translate.instant('customerInvoices.messages.cancelChargeBack')
        }).pipe(take(1)).subscribe(res => {
            if (res) this.cancelCharge(data);
        });
    }

    cancelCharge(data: any): void {
        this.spinner.open();
        this.webService.put({}, this.webService.HOST + '/invoice/' + data.id + '/cancel-charge')
            .subscribe(
                () => {
                    this.spinner.close();
                    this.toast.showSuccess(this.translate.instant('customerInvoices.messages.cancelChargeSuccess'));
                    this.ngOnInit();
                },
                (err: any) => {
                    this.spinner.close();
                    this.toast.showError(err);
                }
            );
    }

    goBack() {
        this.router.navigate(["/reports"]);
    }

    read(item: any) { // LEER
        if (!this.canViewInvoicesReport()) {
            this.toast.showWarning('No tienes permisos para consultar facturas.');
            return;
        }

        this.router.navigate(['./' + item.id], {relativeTo: this.activatedRoute, queryParamsHandling: 'preserve'});
    }

    openSearchPanel(value: boolean) {
        this.isOpenSearchPanel = value;
        this.filter = new ReportFilter(this.filter);
    }

    search() {
        if (!this.canViewInvoicesReport()) {
            this.toast.showWarning('No tienes permisos para consultar facturas.');
            return;
        }

        this.tableService.filter = new ReportFilter(this.filter);
        this.router.navigate([], {queryParams: {}});
        this.list();
    }

    reset() {
        this.filter = new ReportFilter();
        this.tableService.filter = null;
        this.dataSource = [];
        // delete this.filter.since;
        // delete this.filter.until;
        this.search();
    }

    canViewInvoicesReport(): boolean {
        return this.userPermissionsService.hasPermission('controllers.Invoices.listInvoicesReport');
    }

    // 0.00 solo para cero conocido; ausente/invalido se muestra como '—'
    // (nunca inferir cero desde un dato faltante; parser estricto compartido).
    formatRefundedAmount(value: unknown): string {
        return formatStrictAmount(value);
    }

    canRefundInvoice(): boolean {
        return this.userPermissionsService.hasPermission('controllers.Invoices.processOnboardingInvoicesRefund');
    }

}
